/* DW WISHLIST - step 2, the theme part. Built 2026-09-27 on "Duplicate sandbox - PD Cart Sep26";
   rev 2 the same day (hearts per colour, sizes asked on the wishlist page); rev 3 the same day after
   Pedram's iPhone check (Create account + Log in sheet, one-card wishlist page with a size picker).
   Step 1 is the DW Wishlist helper (a Cloudflare Worker behind the Shopify app proxy
   /apps/dw-wishlist), which keeps each logged-in shopper's list on their own customer record
   (metafield devoteewear.wishlist), so the list follows them to any device. Login to save, like
   Gymshark.

   WHAT A SAVED ITEM MEANS. One product in one colour. The helper stores {product id, variant id};
   for a product with more than one colour the theme sends one variant OF THAT COLOUR (the first one
   in stock, the same variant the colour's card shows), so the colour is kept on the customer record
   and follows the shopper to every device. The size inside that variant is ignored everywhere: the
   wishlist page asks for the size before Add to bag, like Gymshark, so a size Focal preselected is
   never passed off as the shopper's choice. A product with one colour (or no colour option) is saved
   as the product (no variant).
   - A colour heart (a colour card, or the product page showing that colour) is filled when ANY saved
     variant of that colour is on the list, and a tap on it removes that colour only (by variant id).
     Saving Beige never fills the other colours' hearts.
   - A product heart is filled when the product is on the list in any form; a tap removes it (by
     product id).

   What this file does:
   - Hearts. <dw-wishlist-heart> elements come from the theme's Liquid: one on the product page
     (snippets/dw-wishlist-heart.liquid) and one on every product card (snippets/product-item.liquid).
     Each paints itself filled or outline from the list, and a tap saves or removes.
   - The header count (sections/header.liquid), shown only above 0.
   - Logged out: a tap opens the "Save to wishlist" sheet (Create account / Log in, rev 3), remembers
     the item in sessionStorage, and saves it automatically once the shopper is back and logged in
     (and scrolls that card back into view).
   - The wishlist page (sections/dw-wishlist.liquid): one card per saved product + colour, and the
     size picker behind its Add to bag (rev 3).
   - Klaviyo "Saved to wishlist" on every save that changed the list, only if Klaviyo is on the page.

   Speed rules this file keeps:
   - NO request on page load for the hearts or the count. The saved ids arrive in the page
     (#dw-wl-data, printed by snippets/dw-wishlist-data.liquid from the customer's own record).
     The only automatic requests are: the wishlist page (it asks the helper for the list once, and
     each saved product's /products/<handle>.js), and - once per browser session, only for a
     shopper who still has an old Wishlist Power list and no DW list - one list request in idle
     time, which is what copies the old list across.
   - Card hearts cost nothing per card: no request, no per-card timers or observers. Taps are bound
     on the element itself when it is connected.

   Helper calls are relative (/apps/dw-wishlist/...) on the shop's own domain, JSON bodies, cookies
   same-origin. 401 {login:true} means the session ended: the pop-up opens (once; if the page says
   the shopper IS logged in and the helper still says no, a gentle error shows instead, so a login
   can never loop). 409 and 502/503 are retried once, then a quiet error. Nothing here throws out of
   a handler.
   Rollback: Theme settings > Wishlist (DW) off removes this file from every page. */
(function () {
  'use strict';

  if (window.DwWishlist) return;
  var dataEl = document.getElementById('dw-wl-data');
  if (!dataEl || !window.fetch || !window.customElements || !window.JSON) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!D || !D.on) return;

  /* Shopify's t filter HTML-escapes translations (an apostrophe arrives as &#39;), and these words are
     only ever written with textContent, so they are decoded once here. A <textarea> decodes entities
     without parsing or running anything. */
  function decodeAll(obj) {
    var out = {};
    var ta = document.createElement('textarea');
    Object.keys(obj || {}).forEach(function (k) {
      ta.innerHTML = String(obj[k] == null ? '' : obj[k]);
      out[k] = ta.value;
    });
    return out;
  }
  var STR = decodeAll(D.s);
  var PROXY = '/apps/dw-wishlist/';
  var PENDING_KEY = 'dw-wl-pending';
  var CACHE_KEY = 'dw-wl-cache';
  var IMPORT_KEY = 'dw-wl-imported';
  var LOOP_KEY = 'dw-wl-401';
  var PENDING_TTL = 30 * 60 * 1000;
  var CACHE_TTL = 5 * 60 * 1000;
  var LOOP_TTL = 10 * 60 * 1000;

  function now() { return Date.now(); }
  function num(x) { var n = Number(x); return isFinite(n) && n > 0 ? n : null; }

  /* ---- storage (every access guarded: private mode and blocked storage must never break a tap) ---- */
  function sget(store, key) {
    try { var raw = window[store].getItem(key); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }
  function sset(store, key, value) {
    try { window[store].setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  function sdel(store, key) {
    try { window[store].removeItem(key); } catch (e) {}
  }

  /* ---- the list ---- */
  /* Items are {p: product id, v: variant id or null, h: handle or ''}. Ids are plain numbers. */
  function normalize(list) {
    var out = [];
    (list || []).forEach(function (it) {
      var p, v, h;
      if (Array.isArray(it)) { p = it[0]; v = it[1]; h = it[2]; }
      else if (it && typeof it === 'object') { p = it.p; v = it.v; h = it.h; }
      p = num(p);
      if (!p) return;
      out.push({ p: p, v: num(v), h: typeof h === 'string' ? h : '' });
    });
    return out;
  }

  var state = {
    in: !!D.in,
    cid: D.c || null,
    items: normalize(D.i)
  };

  /* The browser's copy of the last list the helper sent, keyed to the customer. The page's printed
     list is read from the customer record while the page renders; right after a change (and when the
     back button restores a page from the browser's memory) this copy is the newer one, so it wins
     for five minutes. It is never used for another customer or when logged out. */
  function readCache() {
    var c = sget('localStorage', CACHE_KEY);
    if (!c || !state.in || !state.cid || String(c.c) !== String(state.cid)) return null;
    if (now() - (c.t || 0) > CACHE_TTL) return null;
    return normalize(c.i);
  }
  function writeCache() {
    if (!state.in || !state.cid) return;
    sset('localStorage', CACHE_KEY, { c: state.cid, t: now(), i: state.items.map(function (it) { return [it.p, it.v, it.h]; }) });
  }
  var usedCache = false;
  if (!state.in) sdel('localStorage', CACHE_KEY);
  else {
    var cached = readCache();
    if (cached) { state.items = cached; usedCache = true; }
  }

  function hasProduct(p) {
    for (var i = 0; i < state.items.length; i++) if (state.items[i].p === p) return true;
    return false;
  }
  /* The saved variant ids of product p that belong to the colour whose variant ids are `ids`. */
  function savedInColour(p, ids) {
    var out = [];
    for (var i = 0; i < state.items.length; i++) {
      var it = state.items[i];
      if (it.p === p && it.v !== null && ids.indexOf(it.v) > -1) out.push(it.v);
    }
    return out;
  }
  /* t = what a heart stands for: {p, v, ids} (one colour of a product) or {p, v: null, ids: null}
     (the product). */
  function isSaved(t) {
    if (!t || !t.p) return false;
    return t.ids ? savedInColour(t.p, t.ids).length > 0 : hasProduct(t.p);
  }

  /* ---- what a heart stands for ---- */
  function idList(str) {
    var out = [];
    String(str || '').split(/[\s,]+/).forEach(function (x) { var n = num(x); if (n && out.indexOf(n) < 0) out.push(n); });
    return out;
  }
  /* The product page's colour map, printed by snippets/dw-wishlist-heart.liquid for a product with
     more than one colour: [[variant id, colour, in stock 1/0], ...]. null for any other product. */
  function colourMap(el) {
    if (el._cv === undefined) {
      el._cv = null;
      var s = el.querySelector('.dw-wl__cv');
      if (s) { try { var j = JSON.parse(s.textContent); if (Array.isArray(j) && j.length) el._cv = j; } catch (e) {} }
    }
    return el._cv;
  }
  /* The colour on screen on the product page. The dw-bundle template: the widget's lead colour (the
     theme form's id input is stale by design there). Otherwise: the variant in Focal's product form. */
  function pdpColour(el, map) {
    var root = document.getElementById('dw-bundle-' + el.getAttribute('data-p'));
    if (root) {
      var lead = root.querySelector('.dw-pick .dw-swatch--lead[aria-pressed="true"]');
      if (lead) return lead.getAttribute('data-value');
    }
    var v = null;
    var formId = el.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : null;
    if (form && form.elements) {
      var input = form.elements.namedItem('id');
      if (input && 'value' in input) v = num(input.value);
    }
    if (!v) v = num(el.getAttribute('data-v'));
    for (var i = 0; i < map.length; i++) if (num(map[i][0]) === v) return map[i][1];
    return null;
  }
  function target(el) {
    var p = num(el.getAttribute('data-p'));
    var t = { p: p, h: el.getAttribute('data-h') || '', c: '', v: null, ids: null };
    if (!p) return t;
    if (el.getAttribute('data-mode') === 'variant') {
      var map = colourMap(el);
      if (!map) return t;
      var c = pdpColour(el, map);
      if (c === null) return t;
      var ids = [], first = null, stocked = null;
      for (var i = 0; i < map.length; i++) {
        if (map[i][1] !== c) continue;
        var id = num(map[i][0]);
        if (!id) continue;
        ids.push(id);
        if (first === null) first = id;
        if (stocked === null && map[i][2]) stocked = id;
      }
      if (!ids.length) return t;
      t.c = c; t.ids = ids; t.v = stocked || first;
      return t;
    }
    var cv = num(el.getAttribute('data-v'));
    if (cv) {
      t.c = el.getAttribute('data-c') || '';
      t.v = cv;
      t.ids = idList(el.getAttribute('data-vs'));
      if (t.ids.indexOf(cv) < 0) t.ids.unshift(cv);
    }
    return t;
  }

  /* ---- painting ---- */
  function paintHeart(el) {
    var b = el._btn || el.querySelector('.dw-wl__btn');
    if (!b) return;
    var on = state.in && isSaved(target(el));
    if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
  }
  function paintAll() {
    var hearts = document.querySelectorAll('dw-wishlist-heart');
    for (var i = 0; i < hearts.length; i++) paintHeart(hearts[i]);
    paintCount();
  }
  function countText(n) {
    return n === 1 ? (STR.one || '1') : String(STR.other || '@n@').replace('@n@', n);
  }
  /* On the wishlist page the header shows the number of tiles on the page (a product that is no longer
     sold, or two saved sizes of one colour, would otherwise make the two numbers disagree on one
     screen). Everywhere else it is the number of saved items. */
  var pageShown = null;
  function paintCount() {
    var n = state.in ? (pageShown !== null ? pageShown : state.items.length) : 0;
    var els = document.querySelectorAll('.dw-wl-count');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = String(n);
      els[i].hidden = n < 1;
    }
    /* The bubble is aria-hidden, so the link's own hidden label carries the number for screen readers. */
    var labels = document.querySelectorAll('a[data-dw-wl-link] .visually-hidden');
    for (var j = 0; j < labels.length; j++) {
      var l = labels[j];
      if (l._base === undefined) l._base = l.textContent;
      var text = n > 0 ? l._base + ', ' + countText(n) : l._base;
      if (l.textContent !== text) l.textContent = text;
    }
  }

  /* Focal fires variant:change on the product form when a colour or size is picked. */
  document.addEventListener('variant:change', function (event) {
    try {
      var form = event.target;
      var variant = event.detail && event.detail.variant;
      var hearts = document.querySelectorAll('dw-wishlist-heart[data-mode="variant"]');
      for (var i = 0; i < hearts.length; i++) {
        var el = hearts[i];
        /* getAttribute, not form.id: on a product form, .id is the hidden input named "id". */
        if (!form || !form.getAttribute || form.getAttribute('id') !== el.getAttribute('data-form')) continue;
        if (variant) {
          if (variant.id) el.setAttribute('data-v', variant.id);
          if (variant.price != null) el.setAttribute('data-price', variant.price);
          var img = variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src;
          if (!img && variant.featured_image) img = variant.featured_image.src || variant.featured_image;
          if (img) el.setAttribute('data-img', img);
        }
        paintHeart(el);
      }
    } catch (e) {}
  });
  /* The bundle widget never fires variant:change; its lead picker is buttons. Repaint after its own
     click handlers have run. */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest || !t.closest('.dw-bundle .dw-pick')) return;
    setTimeout(paintAll, 0);
  });

  /* ---- helper calls ---- */
  function call(route, body, retried) {
    var opts = {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    };
    if (body) {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(PROXY + route, opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (json) {
        if (res.status === 401 && json && json.login) return { login: true };
        if ((res.status === 409 || res.status === 502 || res.status === 503) && !retried) {
          return new Promise(function (r) { setTimeout(r, 450); }).then(function () { return call(route, body, true); });
        }
        if (!res.ok || !json || !Array.isArray(json.items)) return { error: res.status || 'bad' };
        return json;
      });
    }).catch(function () {
      if (!retried) {
        return new Promise(function (r) { setTimeout(r, 450); }).then(function () { return call(route, body, true); });
      }
      return { error: 'network' };
    });
  }

  function adopt(json) {
    state.items = normalize(json.items);
    writeCache();
    sdel('sessionStorage', LOOP_KEY);
    paintAll();
    if (page) page.sync();
  }

  /* ---- toast (one, reused; role=status so screen readers hear it) ---- */
  var toastEl = null, toastTimer = 0;
  function hideToastLater(ms) {
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { if (toastEl) toastEl.classList.remove('is-on'); }, ms);
  }
  function toast(text, withLink) {
    try {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'dw-wl-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        document.body.appendChild(toastEl);
        /* The "View" link stays while the pointer or the keyboard focus is on the toast. */
        var hold = function () { clearTimeout(toastTimer); };
        var release = function () { hideToastLater(2000); };
        toastEl.addEventListener('mouseenter', hold);
        toastEl.addEventListener('focusin', hold);
        toastEl.addEventListener('mouseleave', release);
        toastEl.addEventListener('focusout', release);
      }
      toastEl.textContent = '';
      var span = document.createElement('span');
      span.textContent = text;
      toastEl.appendChild(span);
      if (withLink && D.w && !page) {
        var a = document.createElement('a');
        a.href = D.w;
        a.textContent = STR.view || 'View';
        toastEl.appendChild(a);
      }
      requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
      hideToastLater(withLink ? 6000 : 2400);
    } catch (e) {}
  }

  /* ---- Klaviyo: "Saved to wishlist", for the monthly most-saved report ---- */
  function absUrl(u) {
    if (!u) return '';
    try { return new URL(u, location.origin).href; } catch (e) { return ''; }
  }
  function track(info) {
    setTimeout(function () {
      try {
        var k = window.klaviyo;
        if (!k || typeof k.push !== 'function') return;
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
        var cents = Number(info.price);
        k.push(['track', 'Saved to wishlist', {
          ProductName: info.title || '',
          ProductID: info.p,
          VariantID: info.v || null,
          Color: info.c || null,
          Price: isFinite(cents) ? Math.round(cents) / 100 : null,
          Currency: cur,
          URL: absUrl(info.url),
          ImageURL: absUrl(info.img),
          Market: D.m || (window.Shopify && Shopify.country) || ''
        }]);
      } catch (e) {}
    }, 0);
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function productUrl(handle, v) {
    return root() + 'products/' + encodeURIComponent(handle) + (v ? '?variant=' + v : '');
  }

  /* What Klaviyo (and the pending item) is told about the item behind a heart, read from the page. */
  function heartInfo(el, t) {
    var info = { p: t.p, v: t.v, h: t.h, c: t.c, ids: t.ids, price: el.getAttribute('data-price'), title: el.getAttribute('data-title') || '', img: el.getAttribute('data-img') || '', url: productUrl(t.h, t.v) };
    var card = el.closest('product-item, .product-item');
    if (card) {
      var ti = card.querySelector('.product-item-meta__title');
      if (ti && !info.title) info.title = ti.textContent.trim();
      var img = card.querySelector('.product-item__primary-image:not([hidden])') || card.querySelector('.product-item__primary-image');
      if (img && !info.img) info.img = img.currentSrc || img.src || '';
      var link = card.querySelector('a.product-item__aspect-ratio, a.product-item-meta__title');
      if (link) info.url = link.getAttribute('href') || info.url;
    }
    return info;
  }

  /* ---- save / remove ---- */
  function setBusy(el, on) {
    var b = el && (el._btn || el.querySelector('.dw-wl__btn'));
    if (!b) return;
    if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
  }
  function pop(el) {
    var b = el && (el._btn || el.querySelector('.dw-wl__btn'));
    if (!b) return;
    b.classList.remove('is-pop');
    void b.offsetWidth;
    b.classList.add('is-pop');
  }

  /* 401 {login:true}. Logged out: the pop-up. But when this page was rendered for a logged-in
     customer and the helper still does not see the session a second time within ten minutes, a login
     would come straight back here and the pop-up would reopen for ever: say it failed instead. */
  function onLoginAnswer(info, el, returnPath) {
    if (state.in) {
      var last = sget('sessionStorage', LOOP_KEY);
      if (last && now() - last < LOOP_TTL) {
        sdel('sessionStorage', PENDING_KEY);
        toast(STR.error || 'Error');
        return;
      }
      sset('sessionStorage', LOOP_KEY, now());
    }
    needLogin(info, el, returnPath);
  }

  /* The helper's own add rule, applied locally for the instant paint (the helper's answer replaces
     it): a variant already saved is a no-op; a product saved without a variant is upgraded to this
     variant; a product-level add is a no-op when the product is saved in any form. */
  function addLocal(items, info) {
    var out = items.slice();
    if (info.v) {
      for (var i = 0; i < out.length; i++) if (out[i].v === info.v) return out;
      for (var j = 0; j < out.length; j++) {
        if (out[j].p === info.p && out[j].v === null) { out[j] = { p: info.p, v: info.v, h: info.h }; return out; }
      }
    } else {
      for (var k = 0; k < out.length; k++) if (out[k].p === info.p) return out;
    }
    out.push({ p: info.p, v: info.v || null, h: info.h });
    return out;
  }

  function save(info, el) {
    var before = state.items.slice();
    state.items = addLocal(state.items, info);
    paintAll();
    if (el) { setBusy(el, true); pop(el); }
    var body = { product_id: info.p, handle: info.h };
    if (info.v) body.variant_id = info.v;
    /* Resolves to 'ok', 'login', 'error' or 'network' (the request never got an answer, e.g. the
       page was left while it was in flight), so the pending-item path knows whether to keep it. */
    return call('add', body).then(function (json) {
      if (el) setBusy(el, false);
      if (json.login) { state.items = before; paintAll(); onLoginAnswer(info, el); return 'login'; }
      if (json.error) { state.items = before; paintAll(); toast(STR.error || 'Error'); return json.error === 'network' ? 'network' : 'error'; }
      adopt(json);
      /* "Saved" only when the list the helper sent back really shows this item as saved. */
      if (!isSaved(info)) { toast(STR.error || 'Error'); return 'error'; }
      toast(STR.saved || 'Saved', true);
      if (json.changed !== false) track(info);
      return 'ok';
    });
  }

  /* ops: [{variant_id: n} | {product_id: n}], sent one after another (a colour normally has one
     saved variant; an item copied from Wishlist Power can add a second size of it). */
  function removeOps(t) {
    if (t.ids) return savedInColour(t.p, t.ids).map(function (v) { return { variant_id: v }; });
    return [{ product_id: t.p }];
  }
  function unsave(ops, el) {
    if (!ops.length) return Promise.resolve(true);
    var before = state.items.slice();
    state.items = state.items.filter(function (it) {
      return !ops.some(function (o) { return o.variant_id ? it.v === o.variant_id : it.p === o.product_id; });
    });
    paintAll();
    if (el) setBusy(el, true);
    var i = 0, last = null;
    function next() {
      if (i >= ops.length) return Promise.resolve(last);
      return call('remove', ops[i++]).then(function (json) {
        if (json.login || json.error) return json;
        last = json;
        return next();
      });
    }
    return next().then(function (json) {
      if (el) setBusy(el, false);
      if (json.login) { state.items = before; paintAll(); onLoginAnswer(null, el); return false; }
      if (json.error) {
        if (last) adopt(last); else { state.items = before; paintAll(); }
        toast(STR.error || 'Error');
        return false;
      }
      adopt(json);
      toast(STR.removed || 'Removed', false);
      return true;
    });
  }

  function onHeart(event) {
    event.preventDefault();
    event.stopPropagation();
    var el = event.currentTarget && event.currentTarget.closest('dw-wishlist-heart');
    if (!el) return;
    var b = el._btn;
    if (b && b.getAttribute('aria-busy') === 'true') return;
    var t = target(el);
    if (!t.p) return;
    var info = heartInfo(el, t);
    if (!state.in) { needLogin(info, el); return; }
    if (isSaved(t)) unsave(removeOps(t), el);
    else save(info, el);
  }

  /* ---- the element ---- */
  class DwWishlistHeart extends HTMLElement {
    connectedCallback() {
      if (!this._btn) {
        this._btn = this.querySelector('.dw-wl__btn');
        if (!this._btn) return;
        this._btn.addEventListener('click', onHeart);
        /* A touch that starts on the heart is not the start of a photo swipe or a card tap. */
        this._btn.addEventListener('touchstart', function (e) { e.stopPropagation(); }, { passive: true });
      }
      paintHeart(this);
    }
  }
  if (!window.customElements.get('dw-wishlist-heart')) window.customElements.define('dw-wishlist-heart', DwWishlistHeart);

  /* ---- logged out: the pop-up, and the item waiting for the login ---- */
  function loginHref(returnPath) {
    var path = returnPath || (location.pathname + location.search);
    try {
      var u = new URL(D.l || '/customer_authentication/login', location.origin);
      u.searchParams.set('return_to', path);
      return u.pathname + u.search;
    } catch (e) {
      return '/customer_authentication/login?return_to=' + encodeURIComponent(path);
    }
  }

  /* Theme preview only: Shopify's preview bar (68px, fixed at the bottom of a phone) sits on top of
     whatever is at the bottom of the screen, including the sheets' buttons. While that bar is showing,
     the sheets are lifted by its height. Shoppers on the live store never have the bar, so this is 0. */
  function liftForPreviewBar() {
    var gap = 0;
    try {
      var bar = document.getElementById('PBarNextFrameWrapper');
      if (bar) {
        var cs = getComputedStyle(bar), r = bar.getBoundingClientRect();
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.top < window.innerHeight && r.bottom >= window.innerHeight - 1) gap = Math.round(window.innerHeight - r.top);
      }
    } catch (e) {}
    document.documentElement.style.setProperty('--dw-wl-pbar', gap + 'px');
  }

  function needLogin(info, opener, returnPath) {
    if (info && info.p) sset('sessionStorage', PENDING_KEY, { p: info.p, v: info.v || null, h: info.h || '', c: info.c || '', ids: info.ids || null, t: now(), title: info.title || '', price: info.price || null, img: info.img || '', url: info.url || '' });
    openModal(opener, returnPath);
  }

  var modal = null, modalOpener = null, modalKeep = false;
  function focusables() {
    return [].slice.call(modal.querySelectorAll('a[href], button:not([disabled])')).filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
  }
  function onModalKey(event) {
    if (!modal || modal.hidden) return;
    /* The Escape belongs to the pop-up: stopped here (document, capture) so it cannot also close a
       quick-add panel behind it and pull focus to that card's "+". */
    if (event.key === 'Escape' || event.key === 'Esc') { event.preventDefault(); event.stopPropagation(); closeModal(); return; }
    if (event.key !== 'Tab') return;
    var list = focusables();
    if (!list.length) { event.preventDefault(); return; }
    var first = list[0], last = list[list.length - 1];
    var inside = modal.contains(document.activeElement);
    if (event.shiftKey && (document.activeElement === first || !inside)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !inside)) { event.preventDefault(); first.focus(); }
  }
  function openModal(opener, returnPath) {
    try {
      if (!modal) {
        var tpl = document.getElementById('dw-wl-login-tpl');
        if (!tpl) { location.href = loginHref(returnPath); return; }
        modal = tpl.content.firstElementChild.cloneNode(true);
        document.body.appendChild(modal);
        modal.addEventListener('click', function (event) {
          if (event.target.closest('[data-dw-wl-close]')) { event.preventDefault(); closeModal(); }
          else if (event.target.closest('[data-dw-wl-login]')) { modalKeep = true; }
        });
      }
      /* Create account and Log in: both go to Shopify's one email-code screen (it signs up and logs
         in) with return_to = this page, and both keep the item waiting for the return. */
      var ctas = modal.querySelectorAll('[data-dw-wl-login]');
      for (var k = 0; k < ctas.length; k++) ctas[k].setAttribute('href', loginHref(returnPath));
      var cta = ctas[0] || null;
      modalOpener = opener && opener.querySelector ? (opener.querySelector('button, a') || opener) : opener;
      if (opener && opener.tagName === 'A') modalOpener = opener;
      modalKeep = false;
      liftForPreviewBar();
      var gap = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--dw-wl-gap', (gap > 0 ? gap : 0) + 'px');
      document.documentElement.classList.add('dw-wl-lock');
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.addEventListener('keydown', onModalKey, true);
      var box = modal.querySelector('.dw-wl-modal__box');
      var focusTarget = cta || box;
      setTimeout(function () { try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); } }, 30);
    } catch (e) {
      location.href = loginHref(returnPath);
    }
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.documentElement.classList.remove('dw-wl-lock');
    document.removeEventListener('keydown', onModalKey, true);
    /* Closed without logging in: the shopper said no, so nothing is saved for them later. */
    if (!modalKeep) sdel('sessionStorage', PENDING_KEY);
    if (modalOpener && modalOpener.focus) { try { modalOpener.focus({ preventScroll: true }); } catch (e) {} }
    modalOpener = null;
  }

  /* The header heart: logged out, it opens the same pop-up and brings the shopper back to the
     wishlist page. Without this script it is a plain link to that page, which has its own prompt. */
  document.addEventListener('click', function (event) {
    var a = event.target && event.target.closest && event.target.closest('a[data-dw-wl-link]');
    if (!a || state.in) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0) return;
    event.preventDefault();
    needLogin(null, a, a.pathname + a.search);
  });

  /* The heart the pending item was tapped on: the card of that colour, else any heart of the product. */
  function heartFor(p, c) {
    var list = document.querySelectorAll('dw-wishlist-heart[data-p="' + p + '"]');
    var any = null;
    for (var i = 0; i < list.length; i++) {
      if (!any) any = list[i];
      if (c && list[i].getAttribute('data-c') === c) return list[i];
      if (!c && !list[i].getAttribute('data-c')) return list[i];
    }
    return any;
  }

  /* Back from the login with a pending item: save it now, bring its card back into view, and say so.
     The item is only forgotten once the helper has answered (saved, or refused for good). If the
     shopper leaves the page while the save is in flight, it is still there for the next page, and a
     repeat add is harmless (the helper keeps one copy). A 401 stores it again through needLogin(). */
  var flushing = false;
  function flushPending() {
    var pd = sget('sessionStorage', PENDING_KEY);
    if (!pd || flushing) return;
    if (!state.in) {
      if (now() - (pd.t || 0) > PENDING_TTL) sdel('sessionStorage', PENDING_KEY);
      return;
    }
    if (now() - (pd.t || 0) > PENDING_TTL || !num(pd.p)) { sdel('sessionStorage', PENDING_KEY); return; }
    var v = num(pd.v);
    var ids = Array.isArray(pd.ids) ? idList(pd.ids.join(' ')) : null;
    if (v && ids && ids.indexOf(v) < 0) ids.unshift(v);
    if (v && !ids) ids = [v];
    var info = { p: num(pd.p), v: v, h: pd.h || '', c: pd.c || '', ids: v ? ids : null, title: pd.title || '', price: pd.price, img: pd.img || '', url: pd.url || productUrl(pd.h || '', v) };
    var heart = heartFor(info.p, info.c);
    if (heart && heart.classList.contains('dw-wl--card')) {
      try {
        var r = heart.getBoundingClientRect();
        if (r.top < 60 || r.bottom > window.innerHeight - 60) heart.scrollIntoView({ block: 'center' });
      } catch (e) {}
    }
    flushing = true;
    /* Already saved (another device, or a repeat): nothing to send, just say so. */
    if (isSaved(info)) {
      flushing = false;
      sdel('sessionStorage', PENDING_KEY);
      toast(STR.saved || 'Saved', true);
      return;
    }
    save(info, heart).then(function (result) {
      flushing = false;
      if (result === 'ok' || result === 'error') sdel('sessionStorage', PENDING_KEY);
    });
  }

  /* ---- the wishlist page ---- */
  var page = null;
  var pageEl = document.getElementById('dw-wl-page');
  if (pageEl && state.in) page = makePage(pageEl);

  /* Rev 3 (Pedram's iPhone check): every card is photo (saved colour) + remove X, name (2 lines kept),
     the saved colour as one line of text, price, and one Add to bag at the bottom. Add to bag opens a
     small picker (a sheet on phones, a centred pop-up on desktop): the colour photos (saved colour
     preselected, any other can be picked) and the sizes; a size tap adds to the bag and the cart drawer
     opens, the same one-tap rhythm as the "+" quick add. Sold-out sizes are crossed out and disabled. */
  function makePage(section) {
    var grid = section.querySelector('[data-dw-wl-grid]');
    var empty = section.querySelector('[data-dw-wl-empty]');
    var countEl = section.querySelector('[data-dw-wl-count-text]');
    var form = document.getElementById('dw-wl-page-form');
    var S = {};
    try { S = decodeAll(JSON.parse(section.querySelector('[data-dw-wl-page-strings]').textContent)); } catch (e) {}
    var printed = [];
    try { printed = normalize(JSON.parse(section.querySelector('[data-dw-wl-page-items]').textContent)); } catch (e) {}
    if (!grid || !form) return null;

    var products = {};   /* handle -> promise of the product JSON (or null when it is gone) */
    var cards = {};      /* card key (product + colour) -> card element */
    var listed = false;
    var adding = false;
    var lastRender = Promise.resolve();

    function money(cents) {
      var s = (window.themeVariables && window.themeVariables.settings) || {};
      var format = (s.currencyCodeEnabled ? s.moneyWithCurrencyFormat : s.moneyFormat) || s.moneyFormat || '${{amount}}';
      var value = Number(cents) / 100;
      var html = format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
        var decimals = name.indexOf('no_decimals') > -1 ? 0 : 2;
        var comma = name.indexOf('comma_separator') > -1;
        var parts = value.toFixed(decimals).split('.');
        var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
        return parts[1] ? whole + (comma ? ',' : '.') + parts[1] : whole;
      });
      /* The .ca money format wraps the amount in <span class="money">; this text is written with
         textContent, so the tags are dropped and any entity decoded (a <textarea> parses no markup). */
      var ta = document.createElement('textarea');
      ta.innerHTML = html.replace(/<[^>]*>/g, '');
      return ta.value;
    }
    function sized(src, w) {
      if (!src) return '';
      if (src.indexOf('//') === 0) src = 'https:' + src;
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    function load(handle) {
      if (!handle) return Promise.resolve(null);
      if (!products[handle]) {
        products[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      }
      return products[handle];
    }

    /* ---- reading a product ---- */
    function isColorName(name) {
      return /colou?r|couleur/i.test(String(name || ''));
    }
    function values(product, i) {
      return (product.options[i] && product.options[i].values) || [];
    }
    function colourIndex(product) {
      var idx = -1;
      product.options.forEach(function (o, i) { if (idx < 0 && isColorName(o.name || o)) idx = i; });
      return idx;
    }
    /* The option a tap adds with: the one named size/taille, else the last other option with a choice. */
    function sizeIndex(product, ci) {
      var idx = -1;
      product.options.forEach(function (o, i) { if (idx < 0 && i !== ci && /size|taille/i.test(o.name || '')) idx = i; });
      if (idx < 0) {
        for (var i = product.options.length - 1; i >= 0; i--) if (i !== ci && values(product, i).length > 1) { idx = i; break; }
      }
      return idx;
    }
    function savedVariant(product, it) {
      if (!it.v) return null;
      for (var i = 0; i < product.variants.length; i++) if (product.variants[i].id === it.v) return product.variants[i];
      return null;
    }
    function inColour(product, ci, colour) {
      if (ci < 0 || colour === null) return product.variants.slice();
      return product.variants.filter(function (v) { return v.options[ci] === colour; });
    }
    function colourInStock(product, ci, colour) {
      return inColour(product, ci, colour).some(function (v) { return v.available; });
    }
    /* The saved colour: the saved variant's; for an item saved as the product, the first colour in stock. */
    function savedColour(product, it, ci) {
      if (ci < 0) return null;
      var sv = savedVariant(product, it);
      if (sv) return sv.options[ci];
      for (var i = 0; i < product.variants.length; i++) if (product.variants[i].available) return product.variants[i].options[ci];
      return values(product, ci)[0] || null;
    }
    function colourPhoto(product, ci, colour) {
      var list = inColour(product, ci, colour);
      for (var i = 0; i < list.length; i++) if (list[i].featured_image && list[i].featured_image.src) return list[i].featured_image.src;
      return ci < 0 || values(product, ci).length < 2 ? product.featured_image : null;
    }
    /* Price of a colour: its cheapest variant in stock (else its cheapest), with that variant's compare-at. */
    function colourPrice(product, ci, colour) {
      var list = inColour(product, ci, colour);
      var stocked = list.filter(function (v) { return v.available; });
      var pool = stocked.length ? stocked : list;
      var best = null;
      pool.forEach(function (v) { if (!best || v.price < best.price) best = v; });
      return best ? { cents: best.price, compare: best.compare_at_price } : { cents: product.price, compare: product.compare_at_price };
    }
    function writePrice(el, p) {
      el.textContent = '';
      var now_ = document.createElement('span');
      now_.textContent = money(p.cents);
      el.appendChild(now_);
      if (p.compare && p.compare > p.cents) {
        var was = document.createElement('s');
        was.textContent = money(p.compare);
        was.setAttribute('aria-label', (S.regular || '') + ' ' + money(p.compare));
        el.appendChild(was);
      }
    }
    function sizeText(val) {
      return /^XXXL$/i.test(val) ? '3XL' : (/^XXL$/i.test(val) ? '2XL' : val);
    }
    function variantFor(product, sel) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) if (sel[j] === null || v.options[j] !== sel[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    /* Is there a variant in stock with this value, given the other choices made so far? */
    function valueAvailable(product, sel, idx, val) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (!v.available || v.options[idx] !== val) continue;
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (j === idx || sel[j] === null) continue;
          if (v.options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return true;
      }
      return false;
    }
    /* One card per product and colour: two saved sizes of one colour are one card. */
    function cardKey(it, product) {
      var ci = colourIndex(product);
      var sv = savedVariant(product, it);
      if (ci > -1 && values(product, ci).length > 1) return it.p + ':' + (sv ? sv.options[ci] : '');
      return it.p + ':';
    }

    /* ---- the card ---- */
    function buildCard(it, product) {
      var el = document.createElement('article');
      el.className = 'dw-wl-item';
      var ci = colourIndex(product);
      el._it = it;
      el._product = product;
      el._ci = ci;
      el._colour = savedColour(product, it, ci);

      var media = document.createElement('a');
      media.className = 'dw-wl-item__media';
      media.setAttribute('tabindex', '-1');
      media.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.setAttribute('sizes', '(max-width: 740px) 50vw, (max-width: 999px) 33vw, 25vw');
      media.appendChild(img);
      el.appendChild(media);

      var label = product.title + (ci > -1 && el._colour !== null && values(product, ci).length > 1 ? ' - ' + el._colour : '');
      el._label = label;
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'dw-wl-item__remove';
      rm.setAttribute('aria-label', (S.removeLabel || 'Remove @t@').replace('@t@', label));
      rm.innerHTML = '<svg aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 12 12"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round"/></svg>';
      rm.addEventListener('click', function () { removeCard(el); });
      el.appendChild(rm);

      var info = document.createElement('div');
      info.className = 'dw-wl-item__info';
      var title = document.createElement('a');
      title.className = 'dw-wl-item__title';
      title.textContent = product.title;
      title.title = product.title;
      info.appendChild(title);
      var line = document.createElement('p');
      line.className = 'dw-wl-item__variant';
      info.appendChild(line);
      var price = document.createElement('p');
      price.className = 'dw-wl-item__price';
      info.appendChild(price);
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'dw-wl-item__add';
      add.addEventListener('click', function () { onAdd(el); });
      info.appendChild(add);
      el.appendChild(info);

      el._img = img; el._media = media; el._title = title; el._line = line; el._price = price; el._add = add;
      paintCard(el);
      return el;
    }

    function paintCard(el) {
      var product = el._product, ci = el._ci, colour = el._colour, it = el._it;
      var src = colourPhoto(product, ci, colour) || product.featured_image;
      if (src && el._img.getAttribute('data-src') !== src) {
        el._img.setAttribute('data-src', src);
        el._img.src = sized(src, 540);
        el._img.srcset = [360, 540, 720, 900].map(function (w) { return sized(src, w) + ' ' + w + 'w'; }).join(', ');
      }
      /* The name and photo open the product on the saved colour. */
      var list = inColour(product, ci, colour);
      var linkV = null;
      for (var i = 0; i < list.length && !linkV; i++) if (list[i].available) linkV = list[i].id;
      if (!linkV && list.length) linkV = list[0].id;
      var url = productUrl(product.handle, linkV || it.v || null);
      el._media.href = url;
      el._title.href = url;

      /* "Beige, sold out" only when other colours are still in stock (the picker then offers them);
         when nothing is left the button itself says Sold out. */
      var any = product.variants.some(function (v) { return v.available; });
      var colourOk = colour === null || !any || colourInStock(product, ci, colour);
      var text = colour === null ? '' : (colourOk ? colour : String(S.colourOut || '@c@').replace('@c@', colour));
      if (el._line.textContent !== text) el._line.textContent = text;
      writePrice(el._price, colourPrice(product, ci, colour));

      var add = el._add;
      add.classList.toggle('is-added', !!el._added);
      if (!any) {
        add.disabled = true;
        add.textContent = S.soldOut || 'Sold out';
        add.removeAttribute('aria-haspopup');
        add.removeAttribute('aria-label');
      } else {
        add.disabled = adding;
        add.textContent = el._added ? (S.added || 'Added') : (S.add || 'Add to bag');
        if (direct(el)) add.removeAttribute('aria-haspopup'); else add.setAttribute('aria-haspopup', 'dialog');
        add.setAttribute('aria-label', el._added ? add.textContent : String(S.addLabel || '@t@').replace('@t@', el._label));
      }
    }

    /* Nothing to choose (one variant): Add to bag adds it straight away. */
    function direct(el) {
      return el._product.variants.length === 1;
    }
    function onAdd(el) {
      if (adding) return;
      if (direct(el)) {
        var v = el._product.variants[0];
        if (!v.available) return;
        el._add.setAttribute('aria-busy', 'true');
        addVariant(v).then(function (ok) {
          el._add.removeAttribute('aria-busy');
          if (ok === true) showAdded(el);
        });
        return;
      }
      openPicker(el);
    }
    function showAdded(el) {
      el._added = true;
      paintCard(el);
      clearTimeout(el._addedT);
      el._addedT = setTimeout(function () { el._added = false; if (el.isConnected) paintCard(el); }, 2200);
    }

    /* Adds one variant through Focal's own product form (it posts /cart/add.js and fires the cart
       refresh that opens the Rebuy drawer), with the _dw-wl line property. Resolves true (added),
       false (refused) or null (no answer in 10 s: it may still land, so nothing is claimed). */
    function addVariant(variant) {
      if (adding || !variant || !variant.available) return Promise.resolve(false);
      adding = true;
      Object.keys(cards).forEach(function (k) { cards[k]._add.disabled = true; });
      form.elements.namedItem('id').value = variant.id;
      return new Promise(function (resolve) {
        var settled = false;
        var timer = 0;
        var onResult = function (event) { done(!event.detail || event.detail.status === 'success'); };
        function done(ok) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          form.removeEventListener('cart-notification:show', onResult);
          adding = false;
          Object.keys(cards).forEach(function (k) { paintCard(cards[k]); });
          resolve(ok);
        }
        timer = setTimeout(function () { done(null); }, 10000);
        form.addEventListener('cart-notification:show', onResult);
        try {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        } catch (e) { done(false); }
      });
    }

    /* ---- the picker: colour photos + sizes ---- */
    var pk = null;   /* {root, box, img, title, price, body, note} once built */
    var pkCard = null, pkSel = null, pkSize = -1, pkOpener = null;
    var X_ICON = '<svg focusable="false" aria-hidden="true" width="14" height="14" viewBox="0 0 14 14"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>';

    function buildPicker() {
      var r = document.createElement('div');
      r.className = 'dw-wl-modal dw-wl-modal--pick';
      r.hidden = true;
      r.innerHTML = '<div class="dw-wl-modal__backdrop" data-dw-wl-pick-close></div>'
        + '<div class="dw-wl-modal__box dw-wl-pick" role="dialog" aria-modal="true" aria-labelledby="dw-wl-pick-title" tabindex="-1">'
        + '<div class="dw-wl-pick__top"><img class="dw-wl-pick__img" alt="" width="56" height="70">'
        + '<div class="dw-wl-pick__meta"><p class="dw-wl-pick__title" id="dw-wl-pick-title"></p><p class="dw-wl-pick__price"></p></div>'
        + '<button type="button" class="dw-wl-modal__close" data-dw-wl-pick-close>' + X_ICON + '</button></div>'
        + '<div class="dw-wl-pick__body"></div>'
        + '<p class="dw-wl-pick__note" role="status" aria-live="polite"></p></div>';
      document.body.appendChild(r);
      var o = { root: r, box: r.querySelector('.dw-wl-pick'), img: r.querySelector('.dw-wl-pick__img'), title: r.querySelector('.dw-wl-pick__title'),
        price: r.querySelector('.dw-wl-pick__price'), body: r.querySelector('.dw-wl-pick__body'), note: r.querySelector('.dw-wl-pick__note') };
      r.querySelector('.dw-wl-modal__close').setAttribute('aria-label', S.close || 'Close');
      r.addEventListener('click', function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        if (t.closest('[data-dw-wl-pick-close]')) { event.preventDefault(); if (!adding) closePicker(true); return; }
        if (adding) return;
        var sw = t.closest('.dw-wl-swatch');
        if (sw) { pickValue(Number(sw.getAttribute('data-o')), sw.getAttribute('data-val'), sw); return; }
        var size = t.closest('.dw-wl-size');
        if (size && !size.disabled) { onSize(size); return; }
        if (t.closest('.dw-wl-pick__add')) addChosen(t.closest('.dw-wl-pick__add'));
      });
      return o;
    }

    function openPicker(card) {
      try {
        if (!pk) pk = buildPicker();
        var product = card._product, ci = card._ci;
        pkCard = card;
        pkSize = sizeIndex(product, ci);
        pkSel = product.options.map(function (o, i) { var v = values(product, i); return v.length === 1 ? v[0] : null; });
        if (ci > -1 && card._colour !== null) pkSel[ci] = card._colour;
        /* Any other option with a choice (none in today's catalogue) starts on a value in stock. */
        product.options.forEach(function (o, i) {
          if (i === ci || i === pkSize || pkSel[i] !== null) return;
          var vals = values(product, i);
          for (var k = 0; k < vals.length; k++) if (valueAvailable(product, pkSel, i, vals[k])) { pkSel[i] = vals[k]; break; }
          if (pkSel[i] === null) pkSel[i] = vals[0] || null;
        });
        paintPicker();
        pkOpener = card._add;
        liftForPreviewBar();
        var gap = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--dw-wl-gap', (gap > 0 ? gap : 0) + 'px');
        document.documentElement.classList.add('dw-wl-lock');
        pk.root.hidden = false;
        requestAnimationFrame(function () { pk.root.classList.add('is-open'); });
        document.addEventListener('keydown', onPickKey, true);
        var on = pk.body.querySelector('.dw-wl-swatch[aria-pressed="true"]');
        /* A long colour row starts scrolled to the saved colour (sideways only; the page never moves). */
        var row = on && on.parentNode;
        if (row && row.scrollWidth > row.clientWidth) {
          try {
            var rr = row.getBoundingClientRect(), orr = on.getBoundingClientRect();
            row.scrollLeft += (orr.left + orr.width / 2) - (rr.left + rr.width / 2);
          } catch (e) {}
        }
        /* Focus starts on the picked colour (Enter there changes nothing), never on a size, so a held
           Enter from the Add to bag button cannot add a size by accident. */
        var focusTarget = on || pk.box;
        setTimeout(function () { try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); } }, 30);
      } catch (e) {}
    }

    function closePicker(restoreFocus) {
      if (!pk || pk.root.hidden) return;
      pk.root.classList.remove('is-open');
      pk.root.hidden = true;
      pk.box.classList.remove('is-busy');
      document.documentElement.classList.remove('dw-wl-lock');
      document.removeEventListener('keydown', onPickKey, true);
      var opener = pkOpener;
      pkCard = null; pkOpener = null;
      if (restoreFocus !== false && opener && opener.isConnected) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    }

    function onPickKey(event) {
      if (!pk || pk.root.hidden) return;
      /* The Escape belongs to the picker (stopped here, like the Save to wishlist sheet's). */
      if (event.key === 'Escape' || event.key === 'Esc') { event.preventDefault(); event.stopPropagation(); if (!adding) closePicker(true); return; }
      if (event.key !== 'Tab') return;
      var list = [].slice.call(pk.box.querySelectorAll('button:not([disabled]), a[href]')).filter(function (n) { return n.offsetParent !== null; });
      if (!list.length) { event.preventDefault(); return; }
      var first = list[0], last = list[list.length - 1];
      var inside = pk.box.contains(document.activeElement);
      if (event.shiftKey && (document.activeElement === first || !inside || document.activeElement === pk.box)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !inside)) { event.preventDefault(); first.focus(); }
    }

    function setNote(text, isError) {
      if (!pk) return;
      if (pk.note.textContent !== text) pk.note.textContent = text;
      pk.note.classList.toggle('is-error', !!isError);
    }

    function group(labelHtmlParts) {
      var g = document.createElement('div');
      g.className = 'dw-wl-pick__group';
      var p = document.createElement('p');
      p.className = 'dw-wl-pick__label';
      labelHtmlParts.forEach(function (part) {
        var n = part.b ? document.createElement('b') : document.createElement('span');
        n.textContent = part.t;
        p.appendChild(n);
      });
      g.appendChild(p);
      return g;
    }

    function paintPicker() {
      var card = pkCard, product = card._product, ci = card._ci, sel = pkSel;
      var colour = ci > -1 ? sel[ci] : null;
      pk.title.textContent = product.title;
      var chosen = variantFor(product, sel);
      writePrice(pk.price, chosen ? { cents: chosen.price, compare: chosen.compare_at_price } : colourPrice(product, ci, colour));
      var src = colourPhoto(product, ci, colour) || product.featured_image;
      if (src) {
        var want = sized(src, 160);
        if (pk.img.getAttribute('src') !== want) { pk.img.src = want; pk.img.srcset = sized(src, 112) + ' 112w, ' + want + ' 160w'; pk.img.sizes = '56px'; }
      }
      /* The body is redrawn on every pick; the colour row keeps its sideways scroll. */
      var oldRow = pk.body.querySelector('.dw-wl-pick__swatches');
      var keepScroll = oldRow && pk.body._p === product.id ? oldRow.scrollLeft : null;
      pk.body._p = product.id;
      pk.body.textContent = '';
      var colourOk = colour === null || colourInStock(product, ci, colour);

      /* Colour: "Colour: Beige" and the colour photos. */
      if (ci > -1) {
        var head = [{ t: (S.colour || 'Colour') + ': ' }, { t: colourOk ? colour : String(S.colourOut || '@c@').replace('@c@', colour), b: true }];
        var g = group(head);
        var vals = values(product, ci);
        var row = null;
        if (vals.length > 1) {
          row = document.createElement('div');
          row.className = 'dw-wl-pick__swatches';
          row.setAttribute('role', 'group');
          row.setAttribute('aria-label', S.colour || 'Colour');
          vals.forEach(function (val) {
            var b = document.createElement('button');
            b.type = 'button';
            var ok = colourInStock(product, ci, val);
            var photo = colourPhoto(product, ci, val);
            b.className = 'dw-wl-swatch' + (photo ? '' : ' dw-wl-swatch--text') + (ok ? '' : ' is-out');
            b.setAttribute('data-o', ci);
            b.setAttribute('data-val', val);
            b.setAttribute('aria-pressed', String(val === colour));
            b.setAttribute('aria-label', ok ? val : String(S.colourOut || '@c@').replace('@c@', val));
            b.title = val;
            if (photo) {
              var im = document.createElement('img');
              im.alt = '';
              im.decoding = 'async';
              im.width = 44; im.height = 55;
              im.src = sized(photo, 120);
              b.appendChild(im);
            } else b.textContent = val;
            row.appendChild(b);
          });
          g.appendChild(row);
        }
        pk.body.appendChild(g);
        if (keepScroll !== null && row) row.scrollLeft = keepScroll;
      }

      /* Any other option with a choice (not in today's catalogue): plain chips that only select. */
      product.options.forEach(function (o, i) {
        if (i === ci || i === pkSize || values(product, i).length < 2) return;
        var g2 = group([{ t: (o.name || '') + ': ' }, { t: sel[i] || '', b: true }]);
        var row2 = document.createElement('div');
        row2.className = 'dw-wl-pick__swatches';
        values(product, i).forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'dw-wl-swatch dw-wl-swatch--text' + (valueAvailable(product, sel, i, val) ? '' : ' is-out');
          b.setAttribute('data-o', i);
          b.setAttribute('data-val', val);
          b.setAttribute('aria-pressed', String(sel[i] === val));
          b.textContent = val;
          row2.appendChild(b);
        });
        g2.appendChild(row2);
        pk.body.appendChild(g2);
      });

      /* Sizes: a tap adds. Sold out = crossed out and disabled. */
      if (pkSize > -1) {
        var g3 = group([{ t: S.size || 'Size' }]);
        var sizes = document.createElement('div');
        sizes.className = 'dw-wl-pick__sizes';
        /* 4 to 6 equal columns: 5 sizes fill the row, 3 stay chip-sized. */
        sizes.style.setProperty('--dw-wl-n', String(Math.max(4, Math.min(6, values(product, pkSize).length))));
        sizes.setAttribute('role', 'group');
        sizes.setAttribute('aria-label', S.size || 'Size');
        values(product, pkSize).forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'dw-wl-size';
          b.setAttribute('data-val', val);
          b.textContent = sizeText(val);
          var ok = valueAvailable(product, sel, pkSize, val);
          b.disabled = !ok;
          b.setAttribute('aria-pressed', 'false');
          if (!ok) b.setAttribute('aria-label', sizeText(val) + ', ' + (S.soldOut || 'Sold out'));
          else if (b.textContent !== val) b.setAttribute('aria-label', val);
          sizes.appendChild(b);
        });
        g3.appendChild(sizes);
        pk.body.appendChild(g3);
        setNote(colourOk ? (S.tapSize || '') : (S.pickColour || ''));
      } else {
        /* No size to tap (e.g. a one-colour accessory with a choice of colour only): one Add to bag. */
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'dw-wl-item__add dw-wl-pick__add';
        btn.textContent = S.add || 'Add to bag';
        btn.disabled = !(chosen && chosen.available);
        var g4 = document.createElement('div');
        g4.className = 'dw-wl-pick__group';
        g4.appendChild(btn);
        pk.body.appendChild(g4);
        setNote(colourOk ? '' : (S.pickColour || ''));
      }
    }

    function pickValue(i, val, btn) {
      if (!pkCard || val === null) return;
      pkSel[i] = val;
      paintPicker();
      var again = pk.body.querySelector('.dw-wl-swatch[data-o="' + i + '"][aria-pressed="true"]');
      if (again && btn && document.activeElement !== again) { try { again.focus({ preventScroll: true }); } catch (e) {} }
    }

    function onSize(btn) {
      var card = pkCard;
      if (!card || adding) return;
      var sel = pkSel.slice();
      sel[pkSize] = btn.getAttribute('data-val');
      var v = variantFor(card._product, sel);
      if (!v || !v.available) return;
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-busy', 'true');
      pk.box.classList.add('is-busy');
      setNote(S.adding || '');
      addVariant(v).then(function (ok) { afterAdd(card, ok, btn); });
    }
    function addChosen(btn) {
      var card = pkCard;
      if (!card || adding) return;
      var v = variantFor(card._product, pkSel);
      if (!v || !v.available) return;
      btn.setAttribute('aria-busy', 'true');
      pk.box.classList.add('is-busy');
      setNote(S.adding || '');
      addVariant(v).then(function (ok) { afterAdd(card, ok, btn); });
    }
    function afterAdd(card, ok, btn) {
      if (!pk) return;
      pk.box.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
      if (ok === true) {
        /* Added: the picker closes, the cart drawer is opening, the card says "Added to bag". */
        if (pkCard === card) closePicker(true);
        if (card.isConnected) showAdded(card);
        return;
      }
      btn.setAttribute('aria-pressed', 'false');
      if (ok === false) setNote(S.addFailed || '', true);
      else setNote('');
    }

    /* Remove every saved entry behind this card (normally one). A product-level entry goes by
       product id; a saved variant by its own id, so the product's other colours stay. */
    function removeCard(el) {
      var entries = el._entries || [el._it];
      var ops = [];
      entries.forEach(function (it) {
        if (it.v) ops.push({ variant_id: it.v });
        else if (!ops.some(function (o) { return o.product_id === it.p; })) ops.push({ product_id: it.p });
      });
      /* Where the keyboard goes next: the neighbouring card's title, or the empty state. */
      var sib = el.nextElementSibling || el.previousElementSibling;
      var sibKey = sib && sib._key;
      el.classList.add('is-leaving');
      unsave(ops, null).then(function (ok) {
        if (!ok) { el.classList.remove('is-leaving'); return; }
        lastRender.then(function () {
          try {
            var next = sibKey && cards[sibKey];
            if (next && next.isConnected && next._title) next._title.focus();
            else if (empty && !empty.hidden) {
              var b = empty.querySelector('a, button');
              if (b) b.focus();
            }
          } catch (e) {}
        });
      });
    }

    function setCount(n) {
      if (!countEl) return;
      countEl.hidden = n < 1;
      countEl.textContent = n === 1 ? countEl.getAttribute('data-one') : String(countEl.getAttribute('data-other') || '').replace('@n@', n);
    }

    var renderSeq = 0;
    function render(items) {
      var seq = ++renderSeq;
      var list = items.slice().reverse();   /* newest first */
      lastRender = Promise.all(list.map(function (it) {
        return load(it.h).then(function (product) {
          /* Hidden when the product is gone, the handle now belongs to another product, or it costs
             nothing (the $0 gift must never get an Add to bag here). */
          if (!product || Number(product.id) !== it.p || !product.variants || !product.variants.length) return null;
          if (!(Number(product.price_max) > 0)) return null;
          return { it: it, product: product };
        });
      })).then(function (rows) {
        if (seq !== renderSeq) return;
        var keep = {};
        var order = [];
        rows.forEach(function (row) {
          if (!row) return;
          var k = cardKey(row.it, row.product);
          if (!keep[k]) { keep[k] = []; order.push(k); }
          keep[k].push(row);
        });
        var frag = document.createDocumentFragment();
        order.forEach(function (k) {
          var group_ = keep[k];
          var card = cards[k];
          if (!card) {
            try { card = buildCard(group_[0].it, group_[0].product); } catch (e) { return; }
            cards[k] = card;
            card._key = k;
          }
          card._entries = group_.map(function (r) { return r.it; });
          frag.appendChild(card);
        });
        Object.keys(cards).forEach(function (k) { if (!keep[k]) delete cards[k]; });
        grid.textContent = '';
        grid.appendChild(frag);
        grid.removeAttribute('aria-busy');
        if (pkCard && !pkCard.isConnected) closePicker(false);
        var n = order.length;
        setCount(n);
        pageShown = n;
        paintCount();
        if (empty) empty.hidden = n > 0;
        grid.hidden = n < 1;
      });
      return lastRender;
    }

    /* Start with the printed list (products start loading at once), then take the helper's answer. */
    printed.forEach(function (it) { load(it.h); });
    var first = render(usedCache ? state.items.filter(function (it) { return it.h; }) : printed);
    call('list').then(function (json) {
      listed = true;
      if (json.login) { onLoginAnswer(null, null, location.pathname + location.search); return; }
      if (json.error) return;
      sset('sessionStorage', IMPORT_KEY, 1);
      first.then(function () { adopt(json); });
    });

    return {
      sync: function () {
        if (!listed && !state.items.length) return;
        render(state.items);
      },
      close: function () { closePicker(false); }
    };
  }

  /* ---- start ---- */
  if (pageEl && !state.in) {
    var pageLogins = pageEl.querySelectorAll('[data-dw-wl-page-login]');
    for (var pl = 0; pl < pageLogins.length; pl++) pageLogins[pl].setAttribute('href', loginHref(location.pathname + location.search));
  }
  paintAll();
  flushPending();
  /* A shopper who still has an old Wishlist Power list and no DW list: ask the helper once per
     browser session, which copies the old list across, then repaint. Nobody else pays for this. */
  if (state.in && D.imp && !page && !sget('sessionStorage', IMPORT_KEY)) {
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };
    idle(function () {
      sset('sessionStorage', IMPORT_KEY, 1);
      call('list').then(function (json) { if (!json.error && !json.login) adopt(json); });
    });
  }
  /* The back button can restore a page from memory, with the hearts as they were before a change on
     another page. The browser's copy of the list is newer then. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    /* Back from the login page to a page kept in memory: the pop-up would still be open over it. */
    if (modal && !modal.hidden) closeModal();
    if (page && page.close) page.close();
    if (!state.in) return;
    var c = readCache();
    if (c) { state.items = c; paintAll(); }
  });

  window.DwWishlist = {
    version: '2026-09-27.3',
    state: function () { return { in: state.in, items: state.items.map(function (it) { return [it.p, it.v]; }) }; },
    paint: paintAll
  };
})();
